<template>
  <div>
    <h1 class="mobiTitle white lg content" id="contentTitle">
      {{ $t("terms") }}
    </h1>
    <span v-if="lang_Mobif == 'slovakia'">
      <terms-slovak />
    </span>
    <span v-if="lang_Mobif == 'czech'">
      <terms-czech />
    </span>
    <span v-else>
      <terms-english />
    </span>
  </div>
</template>

<script>
import TermsSlovak from "./TermsSlovak";
import TermsCzech from "./TermsCzech";
import TermsEnglish from "./TermsEnglish";

import { mapGetters } from "vuex";

export default {
  computed: mapGetters(["lang_Mobif", "country_Mobif"]),
  components: {
    TermsSlovak,
    TermsCzech,
    TermsEnglish,
  },
  methods: {},
};
</script>
<style scoped lang="scss">
.mobiFaq {
  margin: 25px 0px;
  .mobitxt {
    margin: 8px 0px;
    padding-left: 25px;
  }
  .mobiTitle {
    padding: 12px;
    background: #f1f1f1;
  }
  li {
    font-size: 1rem;
    line-height: 1.2;
    font-weight: 300;
    margin-bottom: 8px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mobiflix/Terms.vue